import React from 'react';

import { HomeLoader } from '@opendoor/bricks/core';

import styles from '../styles/FullPageHomeLoaderStyle.less';
import { ContentWrapper } from './ContentWrapper';

const FullPageHomeLoader: React.FC = () => (
  <ContentWrapper>
    <div className={styles['loader-container']}>
      <div className={styles['loader-spacer']}>
        <HomeLoader />
      </div>
    </div>
  </ContentWrapper>
);

export default FullPageHomeLoader;
